import { Component } from '@angular/core';
import { animate, animateChild, query, state, style, transition, trigger } from '@angular/animations';
import { nanoid } from 'nanoid';
declare var $:any;

@Component({
	selector: 'app-toast',
	templateUrl: 'toast.component.html',
	standalone: false,
	styleUrls: ['toast.component.scss'],
	animations: [
		trigger('slideIn', [
			state('*', style({
				transform: 'translateY(62px) ',
				opacity: 1,
				filter: 'blur(0) saturate(100%)',
			})),
			state('void', style({
				transform: 'translateY(0)  ',
				opacity: 0,
				filter: 'blur(2px) saturate(50%)'
			})),
			transition('void => *', animate('.5s ease-in-out')),
		]),
		trigger('slideOut', [
			state('*', style({
				transform: 'translateY(62px)',
				opacity: 1,
			})),
			state('void', style({
				transform: 'translateY(0)',
				opacity: 0,
			})),
			transition('* => void', animate('.5s ease-in-out')),
		]),
		trigger('triggerChildAnimation', [
			transition(':enter, :leave', [animate('0s'), query('*', [animateChild()])]),
		]),
		trigger('verticalCollapse', [
			state('*', style({
				height: '*',
			})),
			state('void', style({
				height: '0',
			})),
			transition('* => void', animate('.5s .5s ease-in-out')),
		])
	],
})
export class ToastComponent {

	//array to store information about each toast (unique id, class to be applied)
	toasts = [];
	isUiRenderedFlag = false;
	hideBoxTimeOut: any;
	/**
	 * This function is called to show a toaster with a specific type, also calls a clearToast function to automatically clear the current toast after a stipulated time.
	 * @param toastContent is an object with two keys: type = type of toaster, visibility(optional) = if mobile
	 * @returns unique id for each generated toaster.
	 */
	showToast(toastContent) {
        let id = nanoid(16);
        //0:mobile, 1:load-drawings, 2:failed-notes. 3: failed-drawings, 4: save-failed, 5: mask-limit
        let toastTypeNumber;
        let toasterClass: string;

        let calculatedToast = this.sendToasterClass(toastContent);
        toasterClass = calculatedToast["class"];
        toastTypeNumber = calculatedToast["number"];
		
		if (toastTypeNumber > -1 && toasterClass) {
			this.toasts.unshift({
				id: id,
				class: toasterClass,
				toastTypeNumber: toastTypeNumber,
				show: Date.now(),
				hide: Date.now(),
				...(toastContent.type == 'mask-limit' && { maskLimit: toastContent.maskLimit })
			});
		}

		if (toastContent.type != 'load-drawings') {
			// To reset hideBoxLimitToast timeout
			if (toastContent.type == 'mask-limit') {
				if(this.hideBoxTimeOut) {
					this.clearPendingToasts({ hideBox: true });
				}
				this.hideBoxTimeOut = setTimeout(() => {
					this.clearToast(id);
				}, 4000);
			} else {
				setTimeout(() => {
					this.clearToast(id);
				}, 4000);
			}
		}
		
		this.changeToastPosition();

        return id;
    }

	/**
	 * This function is called to clear the toast with a give unique id
	 * @param id is used to find which particular toast needs to be removed.
	 */
	clearToast(id) {
		let clearToastIndex = this.toasts.findIndex((toast) => {
			return toast.id == id;
		});

		if (clearToastIndex > -1 && this.toasts[clearToastIndex].id == id) {
			if (this.toasts[clearToastIndex].toastTypeNumber == 5 && this.hideBoxTimeOut) {
				clearTimeout(this.hideBoxTimeOut);
				this.hideBoxTimeOut = undefined;
			}
			this.toasts.splice(clearToastIndex, 1);
		}

		this.changeToastPosition();
	}

	/**
	 * This function is called to remove all visible toasts on the screen
	 */
	clearPendingToasts(options: any = {}) {
		if (options.hideBox) {
			let hideBoxToastIndex = -1;
			for (let index = this.toasts.length - 1; index >= 0; index--) {
				const toast = this.toasts[index];
				if(toast.toastTypeNumber == 5) {
					hideBoxToastIndex = index;
					break;
				}
			}
			if (hideBoxToastIndex > -1) {
				this.toasts.splice(hideBoxToastIndex, 1);
			}
		}
		else {
			this.toasts.splice(0, this.toasts.length);
		}
		
		if(this.hideBoxTimeOut) {
			clearTimeout(this.hideBoxTimeOut);
			this.hideBoxTimeOut = undefined;
		}

		this.changeToastPosition();
	}

	changeToastPosition() {
		if(this.toasts[0] && this.toasts[0].toastTypeNumber == 5) {
			$('#toast-component').addClass('mask-limit');
		} else {
			$('#toast-component').removeClass('mask-limit');
		}
	}

	/**
	 * This function is called to check whether the current layout is for mobile or not
	 * @param type is the type of layout, received from the showToast function
	 * @returns true if layout = mobile, false otherwise.
	 */
	visibilityCheck(type) {
		let width = window.innerWidth
			|| document.documentElement.clientWidth
			|| document.body.clientWidth;

		if (type == "mobile" && width <= 991) {
			return true;
		}

		return false;
	}

	/**
	 * This function is called to check the type of toaster and then set the corresponding values for toasterClass and toastTypeNumber.
	 * @param toastContent is an object with two keys: type = type of toaster, visibility(optional) = if mobile
	 * @returns an object with calculated value of the toasterClass to be applied and a identification-number for that specific toaster.
	 */
	sendToasterClass(toastContent) {

		let toasterClass = "", toastTypeNumber = -1;
		if (toastContent.type == "mobile-message") {
			if (toastContent['visibility']) {
				if (this.visibilityCheck(toastContent['visibility'])) {
					toasterClass = 'mobile';
					toastTypeNumber = 0;
				}
			}
		}
		else if (toastContent.type == "load-drawings") {
			toasterClass = 'load-drawing';
			toastTypeNumber = 1;
		}
		else if (toastContent.type == "notes-fetch-failure") {
			toasterClass = 'notes-fail';
			toastTypeNumber = 2;
		}
		else if (toastContent.type == "failed-load-drawings") {
			toasterClass = 'load-drawing-fail';
			toastTypeNumber = 3;
		}
		else if (toastContent.type == "save-data-error") {
			toasterClass = 'save-fail';
			toastTypeNumber = 4;
		} else if(toastContent.type == "mask-limit"){
			toasterClass = 'mask-limit';
			toastTypeNumber = 5;
		}

		return { "class": toasterClass, "number": toastTypeNumber };
	}

	isUiRendered(flag) {
		this.isUiRenderedFlag = flag;
	}

	animEnd(event) {
		if(event.phaseName==="done" && event.toState==="void"){
			$('#toast-component').css('height', 0);
		}
	}
}
